export const environment = {
  reactAppDate: "26-05-2024 | 17:00",
  authUrl: "https://hn-production-users-service.azurewebsites.net/api/users/",
  contentUrl: "https://hn-production-content-service.azurewebsites.net/api/content/",
  usersUrl: "https://hn-production-users-service.azurewebsites.net/api/users/",
  msgUrl: "https://hn-production-messaging-service.azurewebsites.net/",
  wpImagesURL: "https://www.hartman.org.il/wp-json/wp/v2/media/",
  key: "ff1be843f321b040e2786b8c401f691a"
};

